/* import __COLOCATED_TEMPLATE__ from './file-upload.hbs'; */
import {
  DEFAULT_DOCUMENTS_MAX_FILE_SIZE,
  DEFAULT_MAX_FILE_SIZE_TEST,
} from 'client-portal/services/file-upload';
import { action } from '@ember/object';
import { createElement, error } from 'client-portal/utils/banners';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import { isImage } from 'client-portal/utils/file';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import styles from './file-upload.module.scss';

export default class RequestPrescreenerQuestionTypesSpecializedInputsFileUpload extends Component {
  @service fileQueue;
  @service intl;

  styles = styles;

  maxFileSize = isEmberTesting() ? DEFAULT_MAX_FILE_SIZE_TEST : DEFAULT_DOCUMENTS_MAX_FILE_SIZE;
  @tracked currentFile;

  constructor() {
    super(...arguments);
    this.currentFile = this.args.currentFile;
  }

  get queueName() {
    return `${this.clientType}${this.args.questionName}${this.side}`;
  }

  get errorTitle() {
    return this.intl.t('booking.prescreener.fileUpload.errorTitle');
  }

  get defaultErrorMessage() {
    return this.intl.t('booking.prescreener.fileUpload.defaultErrorMessage');
  }

  get maxFileSizeMB() {
    return Math.round(this.maxFileSize / (1024 * 1024));
  }

  get clientType() {
    return this.args.clientType;
  }

  displayErrorBanner(message) {
    let content = createElement('p', { innerText: message });
    error({ title: this.errorTitle, content });
  }

  fileErrorMessage(fileName) {
    let message = this.intl.t('booking.prescreener.fileUpload.fileSizeExceeded', {
      fileName,
      maxFileSizeMB: this.maxFileSizeMB,
    });
    return this.displayErrorBanner(message);
  }

  fileExceedsMaxSize(file) {
    return file.size > this.maxFileSize;
  }

  currentFileUrl(queueName) {
    let file = this.fileQueue.find(queueName)?.files?.[0]?.file;
    return file ? URL.createObjectURL(file) : null;
  }

  flushQueue(queueName) {
    return this.fileQueue.find(queueName).flush();
  }

  get fileUrl() {
    if (this.currentFile) {
      return this.currentFileUrl(this.queueName);
    }
    return undefined;
  }

  get side() {
    return this.args.side || '';
  }

  get isImage() {
    return isImage(this.currentFile);
  }

  @action
  remove() {
    URL.revokeObjectURL(this.currentFile);
    this.flushQueue(this.queueName);
    this.currentFile = undefined;
    this.args.onUpdateFile(undefined, this.side);
  }

  @(task(function* (file) {
    try {
      if (this.fileExceedsMaxSize(file)) {
        this.fileErrorMessage(file.name);
      } else {
        this.currentFile = file;
        this.args.onUpdateFile(file, this.side);
      }
    } catch (err) {
      this.displayErrorBanner(this.defaultErrorMessage);
    }
  }).drop())
  uploadCard;
}
